import { UseFormRegisterReturn } from "react-hook-form";

export interface SelectFormInputProps {
  options:
    | (string | number)[]
    | {
        display: string;
        value: string | number;
      }[];
  formatOption?: (option: string | number) => string;
  registerProps?: UseFormRegisterReturn;
  disabled?: boolean;
  disableEmptyOptions?: boolean;
}

export const SelectFormInput = ({
  options,
  formatOption = (option) => `${option}`,
  registerProps,
  disabled = false,
  disableEmptyOptions = false,
}: SelectFormInputProps) => {
  return (
    <select {...registerProps} disabled={disabled} className="my-select h-btn-md w-full">
      {options.map((option, idx) => {
        const value = typeof option === "string" || typeof option === "number" ? option : option.value;
        const display =
          typeof option === "string" || typeof option === "number" ? formatOption(option) : option.display;
        const isOptionDisabled = !value && disableEmptyOptions;

        return (
          <option key={`${value}` + idx} value={value} disabled={isOptionDisabled}>
            {display}
          </option>
        );
      })}
    </select>
  );
};
